import { FC } from 'react';

const ActionIconStar: FC = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.47901 8.63863L7.91001 9.07063L7.61401 7.74863C7.60401 7.40863 7.70901 7.07063 7.90901 6.79463L8.71001 5.59963L7.55901 5.33363C7.15601 5.21263 6.86501 4.99263 6.67101 4.69363L5.99901 3.66263L5.32501 4.69563C5.13501 4.99063 4.84401 5.21163 4.50701 5.31563L3.28701 5.59863L4.11001 6.82463C4.28801 7.07063 4.39301 7.40863 4.38301 7.74863L4.35601 7.95563L4.08701 9.07063L5.54001 8.63163C5.80401 8.53163 6.15501 8.52663 6.47901 8.63863ZM10.673 11.9926L5.99501 10.5806L1.32401 11.9926L2.34101 7.77763L0.0100098 4.30463L3.75701 3.43863L5.99901 -0.000366211L8.24201 3.44163L11.987 4.30463L9.65601 7.77863L10.673 11.9926Z"
        fill="currentColor"
      />
    </svg>
  );
};

export { ActionIconStar };
